import http from "@/services/http-common";
import authHeader from "@/services/auth-header";

class wsAltarChallenge {
	getCategory(slug) {
		return http.get(
			`/altar-challenges/?filters[title][$eq]=${slug}&populate[custom_button][populate][avatar][fields][0]=url`,
			{
				headers: authHeader(),
			}
		);
	}

	getAllAltars() {
		return http.get(
			`/altar-challenges/?fields[0]=uuid&fields[1]=fullName&fields[2]=description&fields[3]=photoPreparation&fields[4]=photoCompletion&populate[author][fields]=email&populate[author][populate][role][fields]=name`, //&populate[author][fields]=email&populate[author][populate][role][fields]=name
			{
				headers: authHeader(),
			}
		);
	}

	getAltarsByCategory(category, pageSize, page) {
		return http.get(
			`/altar-challenges/?filters[author][role][name][$eq]=${category}&fields[0]=uuid&fields[1]=fullName&fields[2]=description&fields[3]=photoPreparation&fields[4]=photoCompletion&fields[5]=residenceCountry&populate[community_votes][fields]=validate&populate[rme_votes][fields]=validate&pagination[pageSize]=${pageSize}&pagination[page]=${page}`, //&populate[author][fields]=email&populate[author][populate][role][fields]=name
			{
				headers: authHeader(),
			}
		);
	}

	getAltar(uuid) {
		return http.get(
			`/altar-challenges/?filters[uuid][$eq]=${uuid}&fields[0]=uuid&fields[1]=fullName&fields[2]=description&fields[3]=photoPreparation&fields[4]=photoCompletion&fields[5]=residenceCountry&populate[community_votes][fields]=validate&populate[rme_votes][fields]=validate&populate[author][fields]=rme`,
			{
				headers: authHeader(),
			}
		);
	}

	createAnswer(data) {
		return http.post("/altar-challenges/", data, {
			headers: authHeader(),
		});
	}

	voteAltar(id, data) {
		return http.put(`/altar-challenges/${id}`, data, {
			headers: authHeader(),
		});
	}
}

export default new wsAltarChallenge();
